import { useMemo } from "react"
import { MapContainer, Marker } from "react-leaflet"
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import { MapTiles } from "../../map/components/map-tiles"

const MOSCOW_CENTER: [number, number] = [55.7558, 37.6173]
const POINTS_COUNT = 20
// Разброс точек вокруг центра, в градусах (~10 км)
const SPREAD_LAT = 0.09
const SPREAD_LNG = 0.16

const dotIcon = L.divIcon({
    className: 'onboarding-map-icon',
    html: '<span class="onboarding-map-dot"></span>',
    iconSize: [16, 16],
    iconAnchor: [8, 8],
})

// Демо-точки: настоящие магазины не грузим, только показываем, как выглядит карта
const randomPoints = () => Array.from({length: POINTS_COUNT}, () => {
    // Сумма двух случайных гуще к центру — как плотность заведений в городе
    const r = () => (Math.random() + Math.random() - 1)
    return [MOSCOW_CENTER[0] + r() * SPREAD_LAT, MOSCOW_CENTER[1] + r() * SPREAD_LNG] as [number, number]
})

export const MapPreview = () => {
    const points = useMemo(randomPoints, [])

    return (
        // Карта неинтерактивная, чтобы не перехватывать прокрутку лендинга
        <MapContainer
            className="onboarding-map-canvas"
            center={MOSCOW_CENTER}
            zoom={11}
            zoomControl={false}
            attributionControl={false}
            dragging={false}
            scrollWheelZoom={false}
            doubleClickZoom={false}
            touchZoom={false}
            boxZoom={false}
            keyboard={false}
        >
            <MapTiles />
            {points.map((position, i) => (
                <Marker key={i} position={position} icon={dotIcon} interactive={false} />
            ))}
        </MapContainer>
    )
}
